/**
 * Toggle nav menu visibility on small screens
 */
$(function () {
    var activeClassName = 'nav-toggle-active';
    var toggleClassName = 'nav-toggle-button';
    var hiddenClassName = 'hidden';

    var html = $('html');
    var header = $('.site-header');
    var location = header.find('.header');
    var nav = header.find('.nav');
    var button = location.find('.' + toggleClassName);

    // Add the toggle button if it doesn't already exist
    if (location.length !== 0 && button.length === 0) {
        button = $('<a href="#" class="' + toggleClassName + '"><svg viewBox="0 0 24 24"><title>Menu</title><path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" /></svg></a>');
        location.append(button);
    }

    // Toggle nav class on click
    button.on('click', function (e) {
        e.preventDefault();
        nav.toggleClass(hiddenClassName);
    });

    // Make nav hidden on page load
    nav.addClass(hiddenClassName);

    // Add class to document so CSS can tell if nav toggle exists
    html.addClass(activeClassName);
});

/**
 * Toggle fixed header on large screens
 */
$(function () {
    var win = $(window);
    var indicator = $('.site-header .header .side .search');
    var html = $('html');
    var body = $('body');
    var header = $('.site-header');
    var fixed = $('.site-fixed-header');
    var scrolling = false;
    var resizing = false;
    var limit = 10;
    var done = 'scrollResizeDone';
    var name = 'scrolled';

    // Insert the fixed header (if necessary)
    var insertFixed = function () {
        if (fixed.length !== 0) {
            return;
        }

        var nav;

        // New navigation button
        var button = $('<a href="#" class="fixed-nav-toggle-button">'
            + header.find('.nav-toggle-button').html() + '</a>');

        // Create new fixed header based on the real header
        fixed = header.clone();
        nav = fixed.find('.nav');

        // Switch the class on the new header
        fixed.removeClass('site-header').addClass('site-fixed-header');

        // Remove elements that should not appear in the new header
        fixed.find('.header .search').remove();
        fixed.find('.shop').remove();
        fixed.find('.nav-toggle-button').remove();
        nav.removeClass('hidden');

        // Make the new nav toggle button work and it to the header
        button.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            nav.fadeToggle();
        });

        body.on('click', function (e) {
            nav.fadeOut();
        });

        fixed.find('.side').append(button);
        nav.hide();

        // Make the new header hidden so it will fade in nicely
        fixed.hide();

        // Add the new header to the DOM
        body.append(fixed);
    };

    // Show the fixed header
    var showFixed = function () {
        insertFixed();

        if (fixed.is(':visible')) {
            return;
        }

        fixed.fadeIn();
    };

    // Hide the fixed header
    var hideFixed = function () {
        if (fixed.length === 0 || !fixed.is(':visible')) {
            return;
        }

        fixed.fadeOut().promise().done(function () {
            // Hide the nav menu when the header fades out so it does not appear
            // unexpectedly next time the user scrolls down the page.
            fixed.find('.nav').hide();
        });
    };

    // Trigger custom event when user has finished scrolling
    win.on('scroll', function () {
        window.clearTimeout(scrolling);

        scrolling = window.setTimeout(function () {
            win.trigger(done);
        }, limit)
    });

    // Trigger custom event when user has finished resizing
    win.on('resize', function () {
        window.clearTimeout(resizing);

        resizing = window.setTimeout(function () {
            win.trigger(done);
        }, limit)
    });

    // Toggle fixed header visibility: only show the fixed header when the user
    // has scrolled down past the real header and the fixed Storefront footer is
    // invisible (which indicates that the screen is big enough to display the
    // fixed header).
    win.on('load ' + done, function () {
        if (win.scrollTop() > header.height() + 40 &&
            indicator.css('display') !== 'none') {
            return showFixed();
        }

        hideFixed();
    });
});
